import axios from './Api';

export function GetImportTemplate() {
  return axios.get<Aid.IAidGetTemplate>('/aids/importFile/template', { responseType: 'blob' });
}

export function GetNomenclature() {
  return axios.get<Aid.IAidGetTemplate>('/aids/importFile/nomenclator', { responseType: 'blob' });
}
